import React, { useEffect, useRef, useState } from 'react';
import { Popup } from 'devextreme-react';
import Form, { SimpleItem, GroupItem, Label, AsyncRule, StringLengthRule, RequiredRule } from 'devextreme-react/form';
import { useSelector, useDispatch } from 'react-redux'
import DataSource from "devextreme/data/data_source";
import { dialogAppointmentAction } from '../../store/appointment/appointmentDialogReducer';
import http from '../../utils/http';
import uri from '../../utils/uri';
import { defaultAppointment } from '../../data/appointment';
import { Button } from 'devextreme-react/button';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import NuevoQuickly from '../clients/NuevoQuickly';
import { formatDateTime } from '../../data/app';
const Nuevo = props => {

    const { catalogs } = props;

    const [appointment, setAppointment] = useState({ ...defaultAppointment });
    const { id, open, startDate } = useSelector(store => store.appointmentDialog);
    const [saving, setSaving] = useState({
        loading : false,
        text : 'Guardar'
    });
    const dispatch = useDispatch();

    const onHiding = () => {
        setAppointment({ ...defaultAppointment });
        dispatch(dialogAppointmentAction({ id: 0, open: false, startDate: null }));
    }

    const refForm = useRef();

    const guardarAgenda = (params) => {

        let result = refForm.current.instance.validate();

        if (result.isValid) {
            setSaving({loading : true, text:'Guardando...'});
            http(uri.appointments.insert).asPost({ ...appointment, dateTime: moment(appointment.dateTime).format('YYYY-MM-DD HH:mm') }).then(result => {
                notify('Datos guardados correctamente');
                setSaving({loading : false, text:'Guardar'});
                const { onSave } = props;
                var save = onSave?.();
                onHiding();
            }).catch(err => {
                setSaving({loading : false, text:'Guardar'});
                notify(err, 'error');
            });

        }
    }

    useEffect(() => {
        if (id > 0)
            http(uri.appointments.getById(id)).asGet().then(resp => setAppointment(resp));
        else
            setAppointment({...defaultAppointment, dateTime : startDate})
    }, [open]);

    return (
        <div>

            <Popup
                title={`Agenda`}
                width={680}
                height={410}
                onHiding={onHiding}
                visible={open}
                className="bg-fbfbfb"
            >   
                <NuevoQuickly />
                <Form formData={appointment} ref={refForm} colCount={2} >
                    <SimpleItem dataField="clientId" editorType="dxSelectBox" colSpan={2}
                        editorOptions={{
                            dataSource: new DataSource({
                                load: (loadOptions) => {

                                    let params = {};
                                    params.skip = loadOptions.skip || 0;
                                    params.take = loadOptions.take || 10;

                                    if(loadOptions.searchValue)
                                        params.name = loadOptions.searchValue  ;

                                    return http('clients/asCatalog')
                                    .asGet(params).then(x => x.items);
                                    
                                },
                                byKey: id => {
                                    return new Promise(resolve => {

                                        http(uri.clients.getById(id)).asGet().then(resp => {
                                            resp.fullName = `${resp.name} ${resp.lastName}`
                                            resolve(resp);
                                        })
                                    });
                                },
                                paginate : true,
                                pageSize: 10
                            }),
                            valueExpr: "id",
                            displayExpr: 'fullName',
                            searchEnabled: true
                        }} >
                        <Label text="Cliente" />
                        <RequiredRule message="Este campo es requerido" />
                        <StringLengthRule max={100} message="Maximo 100 caracteres" />
                    </SimpleItem>
                    <SimpleItem dataField="doctorId" editorType="dxSelectBox" colSpan={2}
                        editorOptions={{
                            dataSource: catalogs.doctores,
                            valueExpr: "id",
                            displayExpr: 'fullName',
                        }} >
                        <Label text="Doctor" />
                        <RequiredRule message="Este campo es requerido" />
                        <StringLengthRule max={100} message="Maximo 100 caracteres" />
                    </SimpleItem>
                    <SimpleItem dataField="activityId" editorType="dxSelectBox" colSpan={1}
                        editorOptions={{
                            dataSource: catalogs.actividades,
                            valueExpr: "id",
                            displayExpr: 'name',
                        }} >
                        <Label text="Actividad" />
                        <RequiredRule message="Este campo es requerido" />
                        <StringLengthRule max={100} message="Maximo 100 caracteres" />
                    </SimpleItem>
                    <SimpleItem colSpan={1}
                        dataField="dateTime"
                        editorType="dxDateBox"
                        editorOptions={{
                            displayFormat: formatDateTime,
                            openOnFieldClick:true,
                            type:"datetime",
                        }}>
                        <Label text="Fecha hora" />
                    </SimpleItem>
                    <SimpleItem dataField="note" colSpan={2} editorType="dxTextArea">
                        <Label text="Nota" />
                        <StringLengthRule max={250} message="Maximo 250 caracteres" />
                    </SimpleItem>
                    <SimpleItem dataField="notify" editorType="dxSwitch" editorOptions={{
                        switchedOffText: "No",
                        switchedOnText: "Si",
                    }}>
                        <Label text="Enviar SMS" />
                    </SimpleItem>

                </Form>
                <br />
                <Button
                    width={180}
                    text={saving.text} 
                    disabled={saving.loading}
                    type="default"
                    icon='save'
                    onClick={guardarAgenda}
                />
                <br />
            </Popup>
        </div>
    );
}

export default Nuevo;
